import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/api/query-keys';

import { getWorkspaceSettingsContext } from './workspace-context';
import { getWorkspaceSwitcherOptions } from './workspace-switcher';

export function workspaceSettingsContextQueryOptions(
  userId: string,
  organizationId: string,
  teamId: string,
) {
  return queryOptions({
    queryKey: queryKeys.workspaceSettings.context(
      userId,
      organizationId,
      teamId,
    ),
    queryFn: () => getWorkspaceSettingsContext(),
  });
}

export function workspaceSwitcherOptionsQueryOptions(userId: string) {
  return queryOptions({
    queryKey: queryKeys.workspaceSettings.switcher(userId),
    queryFn: () => getWorkspaceSwitcherOptions(),
    staleTime: 5 * 60 * 1000,
  });
}
